import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { globalConfig } from '../utils/globalConfig';
import { MenuService } from 'src/app/modules/layout/services/menu.service';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { GuardService } from '../services/guards.service';
import { PUBLIC_COMUNICADOS_REQUEST } from './http-interceptor.interceptor';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthService,
    private guardService: GuardService,
    private menuService: MenuService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((e: HttpErrorResponse) => {
        if (e.status === 401 && !req.context.get(PUBLIC_COMUNICADOS_REQUEST)) {
          if (sessionStorage.getItem(globalConfig.tokenApi)) {
            this.authService.toastMessage = 'Su sesión ha expirado, por favor ingrese a la plataforma nuevamente.';
          }
          sessionStorage.removeItem(globalConfig.tokenApi);
          this.guardService.resetUsuarioData();
          this.menuService.modalDetalleTransaccionVisible = false;
          if (req.headers.has('skip-Interceptor')) {
            this.router.navigate(['/auth-empresarial/sign-in'], { queryParams: { error: req.headers.get('skip-Interceptor') } });
          } else {
            this.router.navigate(['/auth-empresarial/sign-in']);
          }
        }
        return throwError(() => e);
      }),
    );
  }
}
